/* eslint-disable import/no-duplicates */
import fhirpath from 'fhirpath';
import ptBR from 'date-fns/locale/pt-BR';
import {
  addDays,
  addHours,
  addMinutes,
  addMonths,
  addSeconds,
  addWeeks,
  addYears,
  format,
  parseISO,
} from 'date-fns';

const FOLLOWUP_INTERVAL_EXTENSION_URL =
  'http://healthit.medflowapp/fhir/StructureDefinition/appointment-followup-interval';

type UnitOfTime = 's' | 'min' | 'h' | 'd' | 'wk' | 'mo' | 'a';

export function addUnitsOfTime(
  date: Date,
  unit: UnitOfTime,
  amount: number,
): Date {
  const addFunc: Record<UnitOfTime, (date: Date, amount: number) => Date> = {
    s: addSeconds,
    min: addMinutes,
    h: addHours,
    d: addDays,
    wk: addWeeks,
    mo: addMonths,
    a: addYears,
  };

  const func = addFunc[unit];

  if (func) {
    return func(date, amount);
  }

  return date;
}

export function appointmentDateTime(
  appointment: fhir4.Appointment,
): Date | undefined {
  if (appointment.start) {
    return parseISO(appointment.start);
  }

  const followUpDuration: fhir4.Duration = fhirpath.evaluate(
    appointment,
    `Appointment.extension.where(url='${FOLLOWUP_INTERVAL_EXTENSION_URL}').valueDuration`,
  )[0];

  if (followUpDuration && followUpDuration.value && followUpDuration.unit) {
    const now = new Date();

    return addUnitsOfTime(
      now,
      followUpDuration.code as UnitOfTime,
      followUpDuration.value,
    );
  }

  return undefined;
}

export function appointmentDateTimeDisplay(
  appointment: fhir4.Appointment,
): string {
  const date = appointmentDateTime(appointment);

  if (date) {
    const formatString = appointment.start
      ? "d 'de' MMMM 'de' yyyy (EEEE) 'às' HH:mm"
      : "d 'de' MMMM 'de' yyyy (EEEE)";

    // Format "10 de Abril de 2026 (terça-feira) às 14:30"
    return format(date, formatString, {
      locale: ptBR,
    });
  }

  return 'Sem data';
}

export function appointmentServiceType(appointment: fhir4.Appointment): string {
  return (
    fhirpath.evaluate(
      appointment,
      'Appointment.serviceType.select((text | coding.display).first())',
    )[0] || 'Agendamento'
  );
}
